import { render, staticRenderFns } from "./SampleInformationStep.vue?vue&type=template&id=5110922d&scoped=true"
import script from "./SampleInformationStep.vue?vue&type=script&lang=js"
export * from "./SampleInformationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5110922d",
  null
  
)

export default component.exports